import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "target"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked
    this.targetTarget.classList.toggle("is-disabled", !isChecked)

    if (!isChecked) {
      const checkboxes = this.targetTarget.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => (checkbox.checked = false));
    }
  }
}
